import { $, owlCarousel } from "./imports";

const serviceGridCarousel = () => {

    function initOwlCarousel(selectors) {
        selectors.forEach(selector => {
            let $elementList = $(selector);
            let timeoutCarousel = false;
    
            function initCarousel() {
                console.log("inicio carrusel beneficios")
                $elementList.addClass('owl-carousel').owlCarousel({
                    nav: false,
                    dots: true,
                    margin: 20,
                    navText: [
                        '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                        '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
                    ],
                    rewind: true,
                    items: 1,
                    center: true,
                    autoplay: true,
                    autoplayTimeout: 8000,
                    autoplayHoverPause: true,
                });
            }
    
            function destroyCarousel() {
                $elementList.trigger("destroy.owl.carousel").removeClass("owl-carousel");
            }
    
            function showCarousel() {
                if ($elementList.data("owlCarousel") !== "undefined") {
                    if (window.matchMedia('(max-width: 992px)').matches) {
                        // Mobile iniciiamos carousel
                        initCarousel();
                        $elementList.removeClass('desktop-list');
                    } else {
                        // Desktop
                        // Si tiene más de 4 elementos inicia el carousel
                        destroyCarousel();
                        if ($elementList.children().length > 4) {
                            $elementList.removeClass('desktop-list');
                            initCarousel();
                        } else {
                            // Si hay 4 o menos elementos, añade la clase desktop-list
                            $elementList.addClass('desktop-list');
                        }
                    }
                }
            }
    
            if ($elementList.length > 0) {
                /*==================== WINDOW RESIZE ====================*/
                window.addEventListener('resize', function () {
                    clearTimeout(timeoutCarousel);
                    timeoutCarousel = setTimeout(showCarousel, 250);
                });
    
                showCarousel();
            }
        });
    }
    
    const serviceGridselectors = [
        '.block-service--grid .block-service__list .field__items', 
        '.page-node-type-services-detail .block-service--grid .block-service__list',
    ];

    initOwlCarousel(serviceGridselectors);    

};

export default serviceGridCarousel;